export const isOperator = (user: User | null): boolean => user?.role === "operator";

export const canManageOrganization = (user: User | null, organizationId: string): boolean =>
  isOperator(user) || (user?.role === "member" && user.organization === organizationId);
